module.exports = function ($state, $q, loginService, authMethod, loginAuthMessage) {
    $q.when($state.transition)
        .then((targetState) => {
            if (authMethod !== 'Shopper' && authMethod !== 'Impersonate') {
                loginService.promptForLogin(loginAuthMessage, targetState);
            }
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/authentication-handler.js